<template>
	<div class=" h-full">
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
						:hideCategory="true"
    ></TopAppBar>
    <div class="d-flex h-full flex-column">
	<TopAppBarDrawer></TopAppBarDrawer>
	<main class="main-wrapper" v-if="!showPreview">
	<div class="container container--narrow">
		<div class="position-relative pdt-30  pdb-30">
			<div class="d-flex align-items-center">
				<div class="flex-grow-1">
								<div class="t-headline13 l-spacing66 font-m t-line-h-34">{{indexGroupData ? indexGroupData.name || '월간 청소 및 위생 관리' : '월간 청소 및 위생 관리'}}</div>
								<div class="t-body3 l-spacing42 t-line-h-24 t-color-bodyGrayA mgt-12 font-r" v-if="increaseCount == totalArrayLength">{{$t('3385')}}</div>
								<div class="t-body3 l-spacing42 t-line-h-24 t-color-bodyGrayA mgt-12 font-r" v-else>{{distributionDetail && distributionDetail[increaseCount] ? $t('3449')+': '+distributionDetail[increaseCount].name || '월간 청소 및 위생 관리' : '월간 청소 및 위생 관리'}}</div>
				</div>
							<div  class="process-circle-container">
											<div class="progress-circle p10 overflow-hidden" :class="circleDegree > 180 ? 'over50':''">
															<div class="content">
																			<span class="t-subtitle5 l-spacing54 font-rn t-line-h-26  pdr-4">{{increaseCount}}</span>  <span class="t-subtitle5 l-spacing54 font-rn t-line-h-26 t-color-bodyGrayA"> / {{totalArrayLength}}</span>
																			<span class="circle-left"></span>
															</div>
															<div class="left-half-clipper">
																		<div class="first50-bar"></div>
																		<div class="value-bar" :style="'transform: rotate('+circleDegree+'deg);'"></div>
															</div>
												</div>
										
							</div>
			</div>
		</div>
</div>
<div class="divider"></div>

		

	   <div class="container container--narrow pdb-34" v-if="indexGroupData && indexGroupData.questions">
			<div v-for="(myData, index) in indexGroupData.questions" :key="index">
					<ShortAnswer  :numberValue="index+1" :form="formWithIndex[index+1]" :validField="validateField[index]" :checkListData="myData.question" v-if="myData.question.type.value === 'SHORT_ANSWER'"/>
					<AnswerType :numberValue="index+1" :form="formWithIndex[index+1]" :validField="validateField[index]" :checkListData="myData.question" v-if="myData.question.type.value === 'NUMBER' || myData.question.type.value === 'TEXT'" />
					<ChoiceSingle :numberValue="index+1" :form="formWithIndex[index+1]" :validField="validateField[index]" :checkListData="myData.question" v-if="myData.question.type.value === 'CHOICE_SINGLE'" />
					<ChoiceMultiple :numberValue="index+1" :form="formWithIndex[index+1]" :validField="validateField[index]" :checkListData="myData.question" v-if="myData.question.type.value === 'CHOICE_WORKS'" />
					<DateInput :numberValue="index+1" :form="formWithIndex[index+1]" :validField="validateField[index]" :checkListData="myData.question" v-if="myData.question.type.value === 'DATE'" />
			</div>
		</div>
  	</main>
		<div class="footer bg-white order2">
			<div  class="divider"></div>
			<div  class="container container--narrow pdb-0">
			<div class="d-flex align-items-center justify-content-between pdt-9 pdb-10">
				<div class="d-flex align-items-center w-120">
					<button class="mdc-button btn-white t-color-secondaryBtnText t-nowrap" @click="prev()" @keypress="prev()"  v-if="increaseCount > 1" tabindex="0">
						<i class="material-icons mdc-button__icon pdr-8">keyboard_arrow_left</i>{{$t('3384')}}
					</button>
				</div>
				<div class="d-flex align-items-center w-120 justify-content-end">
				<div class="text-right" @click="next()" @keypress="next()" v-if="increaseCount < totalArrayLength" tabindex="0">
					<button class="mdc-button btn-white t-color-secondaryBtnText t-nowrap font-m">{{$t('3383')}}
						<i class="material-icons mdc-button__icon pdl-8">keyboard_arrow_right</i>
					</button>
				</div>

				<div class="text-right" @click="showPrev()" @keypress="showPrev()" v-if="increaseCount == totalArrayLength" tabindex="0">
					<button class="mdc-button btn-white t-color-secondaryBtnText t-nowrap font-m">{{$t('3389')}}
						<i class="material-icons mdc-button__icon pdl-8">keyboard_arrow_right</i>
					</button>
				</div>
				</div>
			</div>
		</div>
		</div>

 <Preview v-if="showPreview" ref="preview" :dataId="dataId" :formDataAllStep="formDataAllStep" :distributionDetail="distributionDetail"/>
	</div>
	</div>
</template>

<script>
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import checklistApi from '@/api/checklistApi.js'
import Preview from './preview/preview.vue';
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
export default {
	data() {
		return {
			showPreview:false,
			distributionDetail:[],
			indexGroupData:null,
			indexCount:0,
			totalArrayLength:null,
			increaseCount:1,
			circleDegree:0,
			formDataAllStep:[],
			formWithIndex:{},
			submittedData:{},
			dataId : null,
			validateField:[]
		}
	},

	components: {
		'ShortAnswer': () => import('./question/ShortAnswer.vue'),
		'AnswerType': () => import('./question/AnswerType.vue'),
		'ChoiceSingle': () => import('./question/ChoiceSingle.vue'),
		'ChoiceMultiple': () => import('./question/ChoiceMultiple.vue'),
		'DateInput': () => import('./question/DateInput.vue'),
		Preview,
		TopAppBar,
		TopAppBarDrawer
	},

	mixins: [topAppBarMixin],

	watch: {
		$route(to, from) {
			this.initData()
		}
	},
	
	mounted() {
		if(this.$route.query.groupIndex){
			this.increaseCount = this.$route.query.groupIndex;
			this.indexCount = this.increaseCount- 1;
		}
		checklistApi.getQuestionList(this.$route.params).then((response) => {
			// console.log(response.data.data, ' __response.data.data')
			// if(response.data.data && response.data.data.activeRespondentPaper&& response.data.data.activeRespondentPaper.status == 'SOLVING')
			this.distributionDetail = response.data.data.activeRespondentPaper.groups;
			// else
			// this.distributionDetail = response.data.data.paper.questionGroup;
			this.dataId = response.data.data.id;
			this.totalArrayLength = this.distributionDetail.length;
			this.indexGroupData = this.distributionDetail[this.indexCount]
			
   			this.createForm();
			this.countCircle();
			if(this.increaseCount > 1){
				this.setPreviousData();
			}
		}).catch((err) => {
			console.log('errror=> ', err)
			//this.$hideLoading();
			this.$error({ content: err.errMsg }).then(() => {});
		});
	},

	methods: {
		setPreviousData(){
			/// outer looop settting data previous step
			for(let i=0; i< this.indexCount; i++){
				let formIndexData = {};
				/// inner looop settting data previous step
				for(let j=0; j < this.distributionDetail[i].questions.length; j++){
				let formFormat = {
					"text" : "",
					"comment" : "",
					"selected" : [],
					"weight" : {},
					"works" : [],
					"isSolved" : true,
					"image" : null
				};
					if(this.distributionDetail[i].questions[j].type === 'CHOICE_SINGLE'){
						this.distributionDetail[i].questions[j].choices.forEach((value)=>{
							if(value.weight){
								formFormat.selected.push(true);
							}
							else{
								formFormat.selected.push(false);
							}
						})
					}
					else if(this.distributionDetail[i].questions[j].type === 'CHOICE_WORKS'){
						this.distributionDetail[i].questions[j].works.forEach((value)=>{
							if(value.member.id){
								formFormat.works.push(value.member.id);
							}
						})
					}
					else{
						formFormat.text = this.distributionDetail[i].questions[j].questionTextReply;
					}
					formFormat.comment = this.distributionDetail[i].questions[j].comment;
					formFormat.image = this.distributionDetail[i].questions[j].image;
					formIndexData[j+1] = formFormat;
				}
				this.formDataAllStep.push(formIndexData);
			}
		},
		next() {
			this.validateField = this.checkValidation();
			// console.log(this.validateField)
			if(this.validateField.includes(true)){
				return;
			}
			else {
				this.indexGroupData = null;
setTimeout(()=>{
			if (this.formDataAllStep[this.indexCount] === undefined) {
					this.formDataAllStep.push(this.formWithIndex);
			}
				this.indexCount += 1;
				this.increaseCount +=1;
				
				this.indexGroupData = JSON.parse(JSON.stringify(this.distributionDetail[this.indexCount]))
				this.countCircle();
				if (this.formDataAllStep[this.indexCount] === undefined) {
					this.createForm();
				}
				else{
					this.formWithIndex = this.formDataAllStep[this.indexCount]
				}
				window.scrollTo({top: 0, behavior: 'smooth'});
				}, 100)
			}
		},
		checkValidation(){
			let returnValiDationArray = []
			// console.log(this.formWithIndex, this.indexGroupData.questions, ' +++all index');
			this.indexGroupData.questions.forEach((value, index) => {
				if(value.question.type.value == 'CHOICE_SINGLE'){
						if(this.formWithIndex[index+1].selected.includes(true)){
								returnValiDationArray.push(false);
						}
						else {
								returnValiDationArray.push(true);
						}
				}
					else if(value.question.type.value == 'CHOICE_WORKS'){
						if(this.formWithIndex[index+1].works.length > 0){
								returnValiDationArray.push(false);
						}
							else {
								returnValiDationArray.push(true);
						}
				}
			else{
						if(this.formWithIndex[index+1].text){
							returnValiDationArray.push(false);
						}
						else {
								returnValiDationArray.push(true);
						}
				}
			});
			return returnValiDationArray;
		},
		prev() {
			this.validateField = [];
			this.indexGroupData = {};
			setTimeout(()=>{
			// console.log(this.formDataAllStep, ' ___this.formDataAllStep')
			this.indexCount -= 1;
			this.formWithIndex = this.formDataAllStep[this.indexCount]
			this.increaseCount -=1;
			this.indexGroupData = JSON.parse(JSON.stringify(this.distributionDetail[this.indexCount]))
			this.countCircle();
			window.scrollTo({top: 0, behavior: 'smooth'});
			},10);
		},
				countCircle(){
			let totalDegree = 360;
			this.circleDegree = totalDegree*this.increaseCount/this.totalArrayLength;
		},
		showPrev(){
			this.validateField = this.checkValidation();
			// console.log(this.validateField)
			if(this.validateField.includes(true)){
				return;
			}
			else {
			if (this.formDataAllStep[this.indexCount] === undefined) {
					this.formDataAllStep.push(this.formWithIndex);
			}
			this.showPreview =true;
			window.scrollTo({top: 0, behavior: 'smooth'});
			}
			// console.log(this.formDataAllStep, ' __formDataAllStep')
			// console.log(this.distributionDetail, ' __distributionDetail')
		},
		close(){
			if(this.showPreview){
				this.showPreview = false;
			}
			else{
					let params = {
									title: this.$t('3394'),
									content: this.$t('3395'),
									accept: this.$t('3397'),
									cancel: this.$t('3396')
					}
					this.$confirm(params).then((res) => {
						this.temprorayDataSave();
						//this.submitAllStepResults(submitAllQuestionData, this.dataId);
					}).catch((error) => {
						console.log(error)
					})
			}
		},
		temprorayDataSave(){
			let formFormat = {
					"text" : "",
					"comment" : "",
					"selected" : [],
					"weight" : {},
					"works" : [],
					"isSolved" : false,
					"image" : null
				}
			// console.log(this.formDataAllStep, this.distributionDetail, 'check list data submitted')
			let submitAllQuestionData = {};
			for(let i=0; i < this.distributionDetail.length; i++){
				for(let j=0; j< this.distributionDetail[i].questions.length; j++){
					let id = this.distributionDetail[i].questions[j].question.id;
					if(this.formDataAllStep[i] != undefined && this.formDataAllStep[i][j+1])
					submitAllQuestionData[id] = this.formDataAllStep[i][j+1];
					else
					submitAllQuestionData[id] = formFormat;
				}
			}
			this.submitTemporaryResults(submitAllQuestionData, this.dataId)
		},
submitTemporaryResults(data, id){
		this.$showLoading();
		checklistApi.submitCheckListTemp(data, id).then((response) => {
			this.$hideLoading();
			this.$router.push({
				name: 'CheckList'
			})
		}).catch((err) => {
			this.$hideLoading();
		});
	},
		createForm(){
			let formFormat = {
			"text" : "",
			"comment" : "",
			"selected" : [],
			"weight" : {},
			"works" : [],
			"isSolved" : true,
			"image" : null
		}
		let myFormArray = {};
		let returnValiDationArray = [];
			for(let i=0; i < this.indexGroupData.questions.length; i++){
				myFormArray[i+1] = formFormat;
				returnValiDationArray.push(false);
			}
			this.validateField = returnValiDationArray;
			this.formWithIndex = JSON.parse(JSON.stringify(myFormArray))
		}

	}
}
</script>
<style scoped>

	
</style>